import axios, { type AxiosResponse } from 'axios'

import type { ReportingSessionResponseSchema } from '@/api/schemas/reports/operatorReporting'
import type { ReportShiftSummariesResponseSchema } from '@/api/schemas/reports/review'
import { API_ENDPOINTS } from '@/constants/apiEndpoints'
import { REPORTS } from '@/constants/domain/reports'

class ReportSessionsQueries {
    getUnfinishedReportsShiftSummary(userId: number): Promise<AxiosResponse<ReportShiftSummariesResponseSchema>> {
        return axios.get<ReportShiftSummariesResponseSchema>(API_ENDPOINTS.REPORTS.SESSIONS.SHIFT_SUMMARIES, {
            params: {
                user_id: userId,
                status_id: REPORTS.REPORT_SHIFT_SUMMARY_STATUSES.IN_PROGRESS
            }
        })
    }

    startReportingSession(): Promise<AxiosResponse<ReportingSessionResponseSchema>> {
        return axios.post<ReportingSessionResponseSchema>(API_ENDPOINTS.REPORTS.SESSIONS.SHIFT_SUMMARIES)
    }

    stopReportingSession(reportShiftSummaryId: number, statusId: number): Promise<AxiosResponse<ReportingSessionResponseSchema>> {
        return axios.put<ReportingSessionResponseSchema>(
            `${API_ENDPOINTS.REPORTS.SESSIONS.SHIFT_SUMMARIES}/${reportShiftSummaryId}`,
            {
                statusId
            }
        )
    }
}

export default new ReportSessionsQueries()
